export const SET_GAME_INFO = 'SET_GAME_INFO';
export const SET_GAME_ACTIVITY = 'SET_GAME_ACTIVITY';
export const SET_TOTAL_TIME = 'SET_TOTAL_TIME';

export const SET_STUDENTS_INFO = 'SET_STUDENTS_INFO';
export const SET_ACTIVE_PAGE = 'SET_ACTIVE_PAGE';

export const SET_LOGIN = 'SET_LOGIN';
export const SET_LOADING = 'SET_LOADING';